import React, { useContext, useState } from 'react';
import { SELECTED_ACCOUNT_ID } from '../context/account';
import { SELECTED_NOTEBOOK_ID } from '../context/NotebookContext';
import { UserContext } from '../context/UserContext';
import { createAccount } from '../lib/helpers/createAccount';
import redirect from '../lib/redirect';
import ErrorMessages from './ErrorMessages';
import { Input } from './forms';
import { Modal } from './ui';

interface NewAccountModalProps {
  setShowModal: (value: boolean) => void;
}

const NewAccountModal: React.FC<NewAccountModalProps> = ({ setShowModal }) => {
  const { user } = useContext(UserContext);
  const [accountName, setAccountName] = useState('');
  const [errors, setErrors] = useState<{ message: string }[]>([]);

  async function createAccountNotebook() {
    const accountResponse = await createAccount(accountName, user);
    if (accountResponse.errors) {
      setErrors(accountResponse.errors);
      return;
    }

    localStorage.setItem(SELECTED_ACCOUNT_ID, accountResponse.account!.id);
    localStorage.setItem(SELECTED_NOTEBOOK_ID, accountResponse.notebook!.id);

    redirect('/notebook');
    setShowModal(false);
  }

  return (
    <Modal closeModal={() => setShowModal(false)}>
      <div className="pa4 navy">
        <h1 className="f4 fw6 mb3 tc">New Space</h1>
        <ErrorMessages errors={errors} />
        <form
          onSubmit={e => {
            e.preventDefault();
            createAccountNotebook();
          }}
        >
          <Input
            value={accountName}
            onChange={e => setAccountName(e.target.value)}
            placeholder="ex: Work, Personal"
            data-testid="account-name-input"
            autoFocus
          />
        </form>
      </div>

      <div className="flex bt b--light-gray navy">
        <button
          className="w-50 br b--light-gray f6 pa3 tc blue hover-navy"
          onClick={() => setShowModal(false)}
        >
          Cancel
        </button>

        <button
          className="w-50 f6 pa3 tc blue hover-navy"
          onClick={createAccountNotebook}
          disabled={!accountName}
          data-testid="create-account-button"
        >
          Create Space
        </button>
      </div>
    </Modal>
  );
};

export default NewAccountModal;
